import Modal from "../../components/Modal";
import ChecklistIcon from "../../components/icons/ChecklistIcon.jsx";
import "react-toastify/dist/ReactToastify.css";

const MasterBonusConfirm = (props) => {
  console.log(props.type);
  const submitHandler = () => {
    props.setUpdate(true);
    props.closeClick();
  };

  return (
    <Modal
      activeModal={props.activeModal}
      modalHeader="false"
      closeClick={props.closeClick}
      submitHandler={submitHandler}
      type="Oke"
      ButtonConfirmOnly={false}
      widthButtonConfirmOnly="100%"
    >
      <div className="d-flex flex-column w-100 justify-content-center align-items-center w-100">
        <div className="d-flex flex-column w-100 justify-content-center align-items-center">
          <ChecklistIcon />
        </div>

        <div className="d-flex flex-column w-100 justify-content-center align-items-center mt-5">
          <h5 className="fw-bold lh-1 fs-4">
            {props.type === "add" && "Bonus berhasil ditambahkan"}
            {props.type === "edit" && "Bonus berhasil diperbarui"}
          </h5>
          <p className="lh-1 fs-6 w-70">Aturan bonus baru telah tersimpan dan siap digunakan.</p>
        </div>
      </div>
    </Modal>
  );
};

export default MasterBonusConfirm;
